import { InputAdornment } from "@mui/material";
import { FormControlLabel, Slider } from "designSystem/index";
import React, { FunctionComponent } from "react";

interface EnvironmentSliderProps {
    /** Flag whether or not to use degree symbol on the input */
    degrees?: boolean;

    /** Resource of the slider property to be changed */
    item: string;

    /** Max value for the slider */
    max: number;

    /** Callback for onChange */
    onValueChange: (value: number) => void;

    /** Current input value */
    value: number;
}

const SLIDER_STYLES = {
	"&.MuiFormControlLabel-root": {
		overflow: "inherit",
	},
	"& .MuiFormControlLabel-label": {
		width: 65,
	},
	"& .MuiBox-root": {
		overflow: "initial",
	},
};

export const EnvironmentSlider: FunctionComponent<EnvironmentSliderProps> = ({ degrees, item, max, onValueChange, value }) => {
	return (
		<FormControlLabel
			block
			control={(
				<Slider
					aria-labelledby="input-slider"
					includeTextField
					max={max}
					min={0}
					onChange={onValueChange}
					step={1}
					textFieldProps={{
						fullWidth: true,
						id: item,
						InputProps: {
							"aria-labelledby": "input-slider",
							endAdornment: degrees && <InputAdornment position="end">°</InputAdornment>,
						},
					}}
					value={value}
				/>
			)}
			labelPlacement="start"
			res={item}
			sx={SLIDER_STYLES}
		/>
	);
};